module.exports = __webpack_public_path__ + "49961ff35364aabd12a957f6aee7de84.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/bg_line_pattern_shade.png
// module id = 191
// module chunks = 0